var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckSingle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3905 0.501968C13.1326 0.230392 12.6987 0.233855 12.4451 0.509514L6.50446 6.96791C6.25222 7.24213 5.8211 7.24721 5.56247 6.97901L3.49416 4.83424C3.23417 4.56464 2.8003 4.57141 2.54885 4.84898L0.406053 7.21433C0.177498 7.46663 0.183519 7.85287 0.419826 8.09791L5.63451 13.5055C5.89315 13.7737 6.32427 13.7686 6.57651 13.4944L15.5906 3.69467C15.821 3.44412 15.8179 3.05785 15.5835 2.81102L13.3905 0.501968Z",
    fill: "#2DB875"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckSingle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-single.386519502e3a6db94569335ccf9d1a60.svg";